/* tslint:disable */
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TabService {
    public selectedItem = 0;

    constructor() {
    }

    openMarkersTab() {
        this.selectedItem = 0;
    }

    openRegionsTab() {
        this.selectedItem = 1;
    }

    openNeuronsTab() {
        this.selectedItem = 2;
    }

    openROIsTab() {
        this.selectedItem = 3;
    }


}

